export const keys = {
  getSession: () => ['auth', 'session'] as const,
  signInWithEmail: () => ['auth', 'signInWithEmail'] as const,
  signUpWithEmail: () => ['auth', 'signUpWithEmail'] as const,
  changePassword: () => ['auth', 'changePassword'] as const,
  requestPasswordReset: () => ['auth', 'requestPasswordReset'] as const,
  resetPassword: () => ['auth', 'resetPassword'] as const,
  signOut: () => ['auth', 'signOut'] as const,
} as const;
